module.exports = __webpack_public_path__ + "img/cuowu.4239ffeb.png";